export const uuidv4 = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export const indexOfMax = (arr) => {
  if (arr.length === 0) {
    return -1;
  }

  var max = arr[0];
  var maxIndex = 0;

  for (var i = 1; i < arr.length; i++) {
    if (arr[i] > max) {
      maxIndex = i;
      max = arr[i];
    }
  }

  return maxIndex;
}

export const koreanAgeMan = (birth) => {
  if (!birth) {
    return 0;
  }
  var date = new Date();
  var year = date.getFullYear();
  var month = (date.getMonth() + 1);
  var day = date.getDate();
  if (month < 10) month = '0' + month;
  if (day < 10) day = '0' + day;
  var monthDay = month + day;
  birth = birth.replace('-', '').replace('-', '');
  var birthdayy = birth.substr(0, 4);
  var birthdaymd = birth.substr(4, 4);
  var age = monthDay < birthdaymd ? year - birthdayy - 1 : year - birthdayy;
  return age;
}